import { render, staticRenderFns } from "./popup-chejian-list.vue?vue&type=template&id=65bd4279&scoped=true"
import script from "./popup-chejian-list.vue?vue&type=script&lang=js"
export * from "./popup-chejian-list.vue?vue&type=script&lang=js"
import style0 from "./popup-chejian-list.vue?vue&type=style&index=0&id=65bd4279&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bd4279",
  null
  
)

export default component.exports